import { insert, fetch } from "./api";

export const validateOnboardingData = async (data) => {
  return insert({
    nestedResourcePath: ['onboarding/validate'],
    id: null,
    data: { payload: data }
  }).then((response: { data: any[]}) => response.data)
};

export const getStagedTerminalData = async (listSerNo: string[]) => {
  return fetch({
    nestedResourcePath: ['terminal/fetchBySerNo'],
    id: null,
    params: { listSerNo: listSerNo.join(',') }
  }).then(response => response.data ? response.data.data : [])
}

export const importOnboardingData =  async (data, info) => {
  return insert({
    nestedResourcePath: ['onboarding/import'],
    id: null,
    data: { payload: data, info }
  }).then(response => response)
};

export const getOnboardingResult =  async () => {
  return fetch({
    nestedResourcePath: ['onboarding'],
    id: null,
  }).then(response => response)
};

export const getOnboardingID =  async () => {
  return fetch({
    nestedResourcePath: ['onboarding/id'],
    id: null,
  }).then(response => response)
};